// Used to map selected Whatsapp template list to a common reusable format
const mapWATemplate = (draft, source) => {
  draft.header.mediaType = source.HeaderMediaType
    ? source.HeaderMediaType.toLowerCase()
    : "none";

  if (source.HeaderMediaType === "IMAGE" && source.HeaderMediaURL) {
    draft.header.mediaLink = source.HeaderMediaURL;
  }

  draft.header.headerText = source.HeaderText;

  if (source.ParameterFormat === "named") {
    const matchedPattern = source.HeaderText?.match(/\{\{([^}]+)\}\}/);

    if (matchedPattern) {
      draft.header.headerVariableName = matchedPattern[1];
    }
  }

  draft.bodyText = source.BodyText;
  draft.footerText = source.FooterText ? source.FooterText : "";

  draft.button = source.button.map((button) => {
    if (button.ButtonType === "QUICK_REPLY") {
      return {
        buttonType: button.ButtonType,
        buttonPlaceholder: button.ButtonText,
      };
    } else {
      return {
        buttonType: button.ButtonType,
        buttonPlaceholder: button.ButtonText,
        errorMessage: null,
        isPlaceHolderInvalid: false,

        URLPhone:
          button.ButtonType === "PHONE_NUMBER"
            ? button.PhoneNumber
            : button.URL,
      };
    }
  });

  draft.isCallPermission = source.IsCallPermission;
  draft.parameterFormat = source.ParameterFormat;
};

export default mapWATemplate;
